import type { NuxtError } from "#app";

export default defineNuxtPlugin((nuxtApp) => {
    window.addEventListener('unhandledrejection', (event) => {
        let error : NuxtError | undefined = undefined;

        // Normalize to NuxtError
        if (isNuxtError(event.reason))
            error = event.reason;
        else {
            error = createError(event.reason);
            error.fatal = true;
        }

        if (error.fatal)
            // Trigger error page display
            nuxtApp.runWithContext(() => showError(error));
        else
            useToasts().errorToast(getErrorMessage(error));

        event.preventDefault();
    });
});